<img class="img-hgt" src="/assets/banner3.png" alt="iCBMS">
<div class="container-fluid">
  <div class="row">

    <div  class="col-md-4">
      <div class="row">
        <div class="col-md-12">
          <img class="img-hgt" src="/assets/3 Vehicles Resized.png" alt="iCBMS" style="width: 100%;">

        </div>
      
      </div>


    </div>




    <div class="col-md-8">

      <div >
        <div class="card-data">

          <h1 class="text-left">
            <span class="fa-stack fa-1x">
     
            </span>Forgot Password?
          </h1>
          <div class="row">
            <div class="col-md-12" *ngIf="authWebService.isLoading">
              <app-busy [message]="message"></app-busy>
            </div>



            <div class="col-md-12" style="margin-bottom:5px;margin-top:5px">
              <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
                <div class="row">




                  <div class="form-group col-md-6">
                    <input type="email"  placeholder="Please enter your email" name="EmailAddress" formControlName="EmailAddress" class="form-control input-sm"
                      [ngClass]="{'error': form.controls.EmailAddress.invalid  && form.controls.EmailAddress.dirty , 'noerror': form.controls.EmailAddress.valid  && form.controls.EmailAddress.dirty}" />
                    <div class="form-control-feedback text-danger text-small"
                      *ngIf="form.controls.EmailAddress.invalid && form.controls.EmailAddress.dirty">
                      <p *ngIf="form.controls.EmailAddress.errors.required">*Required</p>
                      <p *ngIf="form.controls.EmailAddress.errors.pattern">*Invalid Email Address!</p>
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    Send reset confirmation link by  
                   <input type="radio" name="corspd-type" value="1" ([ngModel])="correspondencechoice" [checked]="correspondencechoice=='1'" (click)="selectcorrespondenceType('1')" /> Email
                   &nbsp;or&nbsp;
                   <input type="radio" name="corspd-type" value="2" ([ngModel])="correspondencechoice" [checked]="correspondencechoice=='2'" (click)="selectcorrespondenceType('2')" /> SMS
                  
                 </div>
                  <div class="form-group col-md-3">
                    <button class="btn btn-block m-clr" [disabled]="!form.valid">Reset Password</button>
                  </div>
                  <div class="form-group col-md-3">
                    <button class="btn btn-block m-clr pull-left" routerLink="/login">Cancel</button>
                  </div>

                </div>
                
              </form>
            </div>

          </div>

        </div>
      </div>

    </div>

  </div>

</div>